'use strct';
import $ from 'jquery';

export default class Expand {
	constructor() {
		if($('.expand').length > 0){
			$('.expand-btn').on('click',function(e){
				e.preventDefault;
				$(this).parent().toggleClass('open');
				$(this).next('.expand-txt').slideToggle();
			});
		}
	}
}